"use client";
import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router";
import { AppContext } from "../../AppProvider";
import Card from "../../Components/ui/Card";
import CBSGCharLoader from "../../Page/CBSGCharLoader";
const PracticeChild = () => {
  const { uri, assignments } = useContext(AppContext);
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id || !uri) {
      console.warn("Missing id or uri:", { id, uri });
      return;
    }

    setLoading(true);
    axios
      .get(`${uri}practice-areas/${id}/`)
      .then((response) => {
        // Validate the response data structure
        const data = response.data;
        if (!data || typeof data !== 'object') {
          throw new Error('Invalid response data structure');
        }
        
        // Ensure required fields are present
        if (!data.name || !data.introduction) {
          throw new Error('Missing required fields in response');
        }

        setPost(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching post:", error);
        setError(error.response?.data?.message || error.message || "Failed to load post.");
        setLoading(false);
      });
      AOS.init({
        duration: 2000,
        offset: 10,
      });
  }, [id, uri]);

  if (loading) return <CBSGCharLoader />;

  if (error || !post) {
    return (
      <div className="text-center py-10 text-red-500">
        <p>Error: {error || "Post not found."}</p>
        <p className="text-sm mt-2">ID: {id}</p>
        <p className="text-sm">URI: {uri}</p>
      </div>
    );
  }
console.log(post.image);
  return (
    
    <div
      className="flex flex-col justify-center items-center p-6 bg-white shadow-lg rounded-lg transition-all duration-500 ease-in-out transform border border-gray-300 mb-6 max-w-7xl mx-auto animate-fade-in" 
    >
      <div className="flex flex-col md:flex-row-reverse w-full">
        {post?.image && (
          <img
            src={post.image}
            alt={post.name}
            className="max-w-xl h-96 object-contain md:mt-11 animate-fade-in"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = '/placeholder-image.jpg'; // Add a placeholder image
            }}
            data-aos="fade-left"
          />
        )}
        <div className="md:px-5 w-full">
          <h1
            className="text-start text-2xl font-bold w-full pb-3 border-b-2 mb-3 border-base_600 text-base_600 animate-fade-in"
          >
            {post?.name}
          </h1>
          <div
            className="dynamic-content mt-5 prose max-w-none animate-fade-in"
            dangerouslySetInnerHTML={{ 
              __html: post?.introduction || '<p>No content available</p>' 
            }}
            data-aos="fade-right"
          />
        </div>
      </div>

      <LoadAssignmentPractice assignments={assignments} type={post?.name} data-aos="fade-down"/>
    </div>
  );
};

export default PracticeChild;

export const LoadAssignmentPractice = ({ assignments, type }) => {
  if (!assignments || !type) return null;

  const filteredAssignments = assignments?.filter(
    (assignment) =>
      Array.isArray(assignment.practice_areas_visible_for) &&
      assignment.practice_areas_visible_for.some((area) => area.name === type)
  );

  return (
    <div className="w-full">
      <h2 className="text-2xl font-semibold mt-6 pb-3 border-b-2 mb-3 border-base_600 text-base_600">
        Related assignments..
      </h2>
      <section className="flex flex-col md:flex-row md:flex-wrap gap-5 justify-start items-start">
        {filteredAssignments.length === 0 && (
          <p className="pl-6">No Assignment Available</p>
        )}
        {filteredAssignments.map((assignment) => (
          <Link key={assignment.id} to={`/assignments/${assignment.id}`}>
            <Card
              title={assignment.title}
              description={assignment.description}
              photo={assignment.photo}
              logo={assignment.company_logo}
              practiceArea={assignment.practice_area?.name}
              subServiceArea={assignment.sub_service_area?.name}
              serviceType={assignment.service_type}
            />
          </Link>
        ))}
      </section>
    </div>
  );
};

LoadAssignmentPractice.propTypes = {
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      photo: PropTypes.string,
      company_logo: PropTypes.string,
      practice_area: PropTypes.shape({
        name: PropTypes.string,
      }),
      sub_service_area: PropTypes.shape({
        name: PropTypes.string,
      }),
      service_type: PropTypes.string,
      practice_areas_visible_for: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string.isRequired,
        })
      ),
    })
  ),
  type: PropTypes.string.isRequired,
};
